import { EditorialClosing } from '~/ui-rocco/pages/detail-shared';
import { ProfessionalProjectsGridSection } from './sections/ProfessionalProjectsGridSection';
import { ProfessionalContactSection } from './sections/ProfessionalContactSection';

/**
 * BC-4572 — revamped professional Projects tab (/case-studies).
 *
 * The tab body is the dark Projects grid, straight to results (the persistent
 * profile header above carries the name / stats / enquiry CTA), then the shared
 * "Talk to us" + About-ArchiPro closing. The Projects grid and "Talk to us"
 * share the dark background, so they sit flush. Rendered behind the revamp flag;
 * the route serves overview + projects data so the grid and reused sections
 * both resolve.
 */
export const ProfessionalProjectsPageRevamp = () => {
    return (
        <main
            id="main-content"
            data-testid="professional-projects-page-revamp"
            className="bg-white"
        >
            <ProfessionalProjectsGridSection />
            <ProfessionalContactSection leadingSpacerHeight={0} />
            <EditorialClosing hideHero />
        </main>
    );
};
